const Suites = ({ header, copy, steps}) => {
    return (
    <section id="suites" className="suites">
        <div className="suites__container">
            <h2>{header}</h2>
            <p>{copy}</p>

            <div className="suites__step--container">
                {steps.map((step, i) => {
                    return (
                        <div className="suites__step" key={i}>
                            <h3>{step.title}</h3>
                            <span>{step.copy}</span>
                        </div>
                    )
                })}
            </div>
        </div>
    </section>
    )
}

export default Suites;